import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Plus, Sparkles, X } from 'lucide-react';
import { FieldError, SectionHeader, inputClass, profileCard } from './ProfileUI';

const SkillsInput = ({ skills, onChange, error }) => {
  const [draft, setDraft] = useState('');

  const addSkill = () => {
    const value = draft.trim();
    if (!value) return;
    onChange([...skills, { name: value }]);
    setDraft('');
  };

  const removeSkill = (index) => {
    onChange(skills.filter((_, skillIndex) => skillIndex !== index));
  };

  return (
    <section className={profileCard}>
      <SectionHeader icon={Sparkles} eyebrow="Step 02" title="Skills graph" />
      <div className="flex gap-2">
        <input
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              addSkill();
            }
          }}
          className={`${inputClass} min-w-0 flex-1`}
          placeholder="React, Python, SQL"
        />
        <button
          type="button"
          onClick={addSkill}
          className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg shadow-purple-500/25 transition hover:-translate-y-0.5 hover:from-purple-700 hover:to-pink-700 focus:outline-none focus:ring-4 focus:ring-purple-500/20"
          aria-label="Add skill"
        >
          <Plus className="h-5 w-5" />
        </button>
      </div>
      <FieldError>{error}</FieldError>
      <div className="mt-3 flex flex-wrap gap-2">
        <AnimatePresence>
          {skills.map((skill, index) => (
            <motion.span
              key={`${skill.name}-${index}`}
              layout
              initial={{ opacity: 0, scale: 0.86, y: 8 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.86, y: -8 }}
              className="inline-flex items-center gap-2 rounded-full border border-purple-400/20 bg-purple-500/20 px-3 py-1.5 text-sm font-semibold text-purple-300 shadow-sm shadow-purple-950/20 transition hover:border-purple-300/50 hover:bg-purple-500/30"
            >
              {skill.name}
              <button
                type="button"
                onClick={() => removeSkill(index)}
                aria-label={`Remove ${skill.name}`}
                className="rounded-full p-0.5 text-purple-100/80 transition hover:bg-white/10 hover:text-white focus:outline-none focus:ring-2 focus:ring-purple-300/40"
              >
                <X className="h-4 w-4" />
              </button>
            </motion.span>
          ))}
        </AnimatePresence>
        {!skills.length && (
          <p className="rounded-xl border border-white/10 bg-slate-950/40 px-4 py-3 text-sm text-slate-400">
            Add skills to help AIVION tune recommendations and project suggestions.
          </p>
        )}
      </div>
    </section>
  );
};

export default SkillsInput;
